/** @format */

import papa from 'papaparse'

export default function jsonToCsv(jsonData) {
  const csv = papa.unparse(jsonData)
  return csv
}
